import type { ValidationReportItem } from '@/domains/report/api/types';

const note = (count: number, total: number, label: string): string =>
  `${count} van ${total} criteria ${count === 1 ? 'is' : 'zijn'} ${label}.`;

/**
 * Extra regels voor de tooltip van een blok met meerdere criteria: hoeveel
 * ervan inconsistent of niet aanwezig zijn. Bij één criterium is de status
 * zelf al het antwoord, dus dan geen regels. Inconsistent staat eerst, net als
 * in blockStatus().
 */
export function statusNotes(items: ValidationReportItem[]): string[] {
  if (items.length < 2) return [];
  const inconsistent = items.filter((i) => i.consistent === false).length;
  const missing = items.filter((i) => i.answers.length === 0).length;
  return [
    ...(inconsistent > 0 ? [note(inconsistent, items.length, 'inconsistent')] : []),
    ...(missing > 0 ? [note(missing, items.length, 'niet aanwezig')] : []),
  ];
}
